<template>
  <el-dialog :append-to-body="true" id="add-authorize-layer" :title="isAdd ? '印章授权' : '印章申请'" :visible.sync="dialogVisible"
    width="608px" :center="true" @close="cancel()">
    <el-form @submit.native.prevent :model="authorizeForm" :rules="authorizeRules" ref="authorizeform" label-width="148px"
      class="authorize-Form">
      <el-form-item prop="userId" label="被授权人姓名">
        <!-- <el-input v-model="authorizeForm.name" style="width: 334px;"></el-input> -->
        <el-select v-if="isAdd" v-model="authorizeForm.userId" @change="showUserInfoHandle" placeholder="请选择授权人">
          <el-option v-for="item in personalList" :key="item.userId" :label="item.name" :value="item.userId">
          </el-option>
        </el-select>
        <span v-show="!isAdd">{{ authorizeForm.userName }}</span>
      </el-form-item>
      <el-form-item prop="position" label="被授权人职位">
        <span>{{ authorizeForm.position }}</span>
      </el-form-item>
      <el-form-item prop="phone" label="被授权人联系手机号">
        <span>{{ authorizeForm.phone }}</span>
      </el-form-item>
      <el-form-item v-if="isAdd" prop="sealId" label="授权印章名称">
        <el-select v-model="authorizeForm.sealId" @change="showSealInfoHandle" placeholder="请选择印章">
          <el-option v-for="item in sealList" :key="item.id" :label="item.sealName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else prop="sealId" label="申请印章名称">
        <span>{{ authorizeForm.sealName }}</span>
      </el-form-item>
      <el-form-item label="">
        <div class="seal-box" v-show="authorizeForm.sealImg">
          <img :src="authorizeForm.sealImg" alt="">
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-btns" v-if="isAdd">
      <el-button type="primary" @click="submitAuthorize" class="btn-ok">确认授权</el-button>
      <el-button type="info" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
    <div class="dialog-btns" v-else>
      <el-button type="primary" @click="agreeHandle()" class="btn-ok">同意申请</el-button>
      <el-button type="primary" @click="unAgreeHandle()" class="btn-cancel">不同意申请</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { initData } from '@/api/data'
import { getToken } from '@/utils/auth'
import { getlistUnauthorizedApi } from '@/api/space/signatures'
import { showAuthInfoApi, unAgreeAuthorizeApi } from '@/api/space/authorize'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dialogVisible: false,
      isAdd: true,
      personalList: [],
      sealList: [],
      authorizeForm: {
        messageId: '',
        userId: '',
        position: '',
        phone: '',
        sealId: '',
        sealImg: '',
        userName: '',
        sealName: ''
      },
      authorizeRules: {
        userId: [
          { required: true, message: '请选择被授权人', trigger: 'blur' }
        ],
        sealId: [
          { required: true, message: '请选择印章', trigger: 'blur' }
        ]
      }
    }
  },
  computed: mapState([
    'currentSpace'
  ]),
  methods: {
    init() {
      this.getPersonListHandle()
      // this.getSealListHandle()
      this.showAuthInfoHandle()
    },
    showAuthInfoHandle() {
      if (!this.isAdd) {
        showAuthInfoApi({
          messageId: this.authorizeForm.messageId
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.authorizeForm.userName = res.data.message.name
            this.authorizeForm.sealName = res.data.message.sealName
            this.authorizeForm.position = res.data.message.part
            this.authorizeForm.sealImg = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + res.data.message.sealData + getToken() + '&nocache=' + new Date().getTime()
            this.authorizeForm.phone = res.data.message.phone.replace(/(\w{3})(\w+)(\w{4})/, function (x, y, z, p) {
              var i = "";
              while (i.length < z.length) { i += "*" }
              return y + i + p
            })
          }
        })
      }
    },
    submitAuthorize() {
      this.$refs.authorizeform.validate((valid) => {
        if (valid) {
          this.$emit('submitHandle', this.authorizeForm)
          this.cancel()
        }
      })
    },
    cancel() {
      this.dialogVisible = false
      this.isAdd = true
    },
    agreeHandle() {
      this.$emit('submitHandle', this.authorizeForm)
      this.cancel()
    },
    unAgreeHandle() {
      this.cancel()
      this.$confirm('该人员的用章申请将被驳回', '用章申请', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        unAgreeAuthorizeApi({
          messageId: this.authorizeForm.messageId
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.$message({
              showClose: true,
              message: '拒绝成功！',
              type: 'success'
            });
            this.$parent.init()
          }
        }).catch(err => {

        })
      }).catch(() => {
        this.$nextTick(() => {
          this.init()
        })
      });
    },
    getPersonListHandle() {
      initData('/companyUser/listUser', {
        pageIndex: 1,
        pageSize: 10,
        companyId: this.currentSpace.companyId || ''
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          // this.authorizeForm.userId = res.data.records[0].id
          // this.personalList = res.data.records
          this.personalList.length = 0;
          res.data.records.forEach(item => {
            if (item.STATUS == '0' && item.isAdmin == '0') {
              this.personalList.push(item)
            }
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getlistUnauthorizedHandle() {
      getlistUnauthorizedApi({
        userId: this.authorizeForm.userId,
        companyId: this.currentSpace.companyId
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.sealList = res.data.sealList
        }
      })
      // getCompanyAuthSealInfoApi({
      //   companyId: this.currentSpace.companyId || ''
      // }).then(res => {
      //   if (res.code !== 200) {
      //     this.$message({
      //       showClose: true,
      //       message: res.message,
      //       type: 'warning'
      //     });
      //   } else {
      //     this.sealList = res.data.sealList
      //     console.log(this.sealList)
      //   }
      // })
    },
    showUserInfoHandle(value) {

      this.personalList.forEach(personal => {
        if (value == personal.userId) {
          this.authorizeForm.position = personal.position
          this.authorizeForm.phone = personal.phone.replace(/(\w{3})(\w+)(\w{4})/, function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) { i += "*" }
            return y + i + p
          })
        }
      })

      this.getlistUnauthorizedHandle()
    },
    showSealInfoHandle(value) {
      this.sealList.forEach(seal => {
        if (value == seal.id) {
          this.authorizeForm.sealImg = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + seal.sealData + getToken()
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-btns {
  width: 405px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.dialog-btns button {
  display: block;
  width: 179px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
}

.seal-box {
  width: 90px;
  height: 90px;
  border: 1px solid rgba(220, 222, 226, 1);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seal-box img {
  display: block;
  max-height: 75px;
  max-width: 75px;
}
</style>
